import { MouseEvent, useCallback } from 'react';

import { Column, SortingState } from '@tanstack/react-table';

import { isDefined } from '@hsp/utilities';

import { ISortEvent } from 'types/components/table';

export const useSortClick = () => {
  return useCallback(
    <TData>(
      e: MouseEvent<HTMLDivElement>,
      column: Column<TData, unknown>,
      sorting: SortingState,
      onSort?: (e: ISortEvent) => void
    ) => {
      const { getCanSort } = column;

      if (!getCanSort()) {
        e.preventDefault();

        return;
      }

      const { ctrlKey } = e;
      const { getCanMultiSort, getIsSorted, getNextSortingOrder, id: field, toggleSorting } = column;
      const next = getIsSorted() ? getNextSortingOrder() : 'asc';
      let clone: SortingState = sorting.map((sort) => ({ ...sort }));

      toggleSorting(next === 'desc', getCanMultiSort() ? ctrlKey : false);

      if (ctrlKey) {
        clone = [...clone, { desc: next === 'desc', id: field }];
      } else {
        if (next === false) {
          clone = clone.filter(({ id }) => field !== id);
        } else {
          const sort = clone.find(({ id }) => id === field);

          if (!isDefined(sort)) {
            clone = [{ desc: next === 'desc', id: field }];
          } else {
            clone = clone.map((item) => {
              if (field === item.id) {
                return { desc: next === 'desc', id: item.id };
              }

              return item;
            });
          }
        }
      }

      onSort?.({ sorts: clone.map(({ desc, id: field }) => ({ direction: desc ? 'desc' : 'asc', field })) });
    },
    []
  );
};
